<template>
  <apexchart type="line" :options="chartOptions" :series="series2"></apexchart>
</template>

<script>
import axios from 'axios'

export default {
  name: 'LoanChart',
  data() {
    return {
      series2: [],
      chartOptions: {
        chart: {
          height: 350,
          type: 'line',
        },
        stroke: {
          width: [0, 4],
        },
        title: {
          text: '在贷余额与不良率',
        },
        dataLabels: {
          enabled: true,
          enabledOnSeries: [1],
        },
        labels: [],
        xaxis: {
          type: 'date',
        },
        yaxis: [{
          title: {
            text: '在贷余额',
          },

        }, {
          opposite: true,
          title: {
            text: '不良率',
          },
        }],
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      axios.get('/dashboard/loan_data').then(res => {
        if (res.data.status === 1) {
          this.chartOptions = {labels: res.data.labels}
          this.series2 = [{
            name: '在贷余额',
            type: 'column',
            data: res.data.series.series1,
          }, {
            name: '不良率',
            type: 'line',
            data: res.data.series.series2,
          }]
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
